/* global d3 */
import { attr } from "cheerio/lib/api/attributes";
import { de } from "date-fns/locale";
import $ from "jquery";

window.dataLayer = window.dataLayer || [];

export default function ({
  home_worldmap_data,
  dictionaryData,
  showCountryInfo,
}) {
  // structure of each home_worldmap_data element
  // {
  //     name: 'country_name',
  //     code: 'country_code',
  //     total: 0, // 0 = no case study, 1 = external content, 2 = case study and or external content
  //     case_studies: [{
  //         name: ""
  //     }],
  //     wip_case_studies: [{
  //         name: ""
  //     }],
  //     partner_content: [{
  //         logo: "",
  //         topic_name: "",
  //         authors: "",
  //         organization: "",
  //         summary: "",
  //         link: ""
  //     }]
  //     non_partner_content: [{
  //         topic_name: "",
  //         link: ""
  //     }]
  // }

  const map_container = $(".js-homepage-map");
  const map_container_width = map_container.width();
  const map_container_height = map_container.height();

  const svg = d3
    .select(".js-homepage-map-svg")
    .append("svg")
    .attr("width", map_container_width)
    .attr("height", map_container_height);

  let width = +svg.attr("width");
  let height = +svg.attr("height");
  let centered;

  const map_default_text = d3
    .selectAll(".home-worldmap-default")
    .filter(function () {
      // exclude "continue to exemplars" link, so it doesn't disappear
      const this_class = d3.select(this).attr("class");
      const is_this_continue = this_class.indexOf("continue-to-exemplars") >= 0;
      return !is_this_continue;
    });
  const zoom_container = d3.select("#home-worldmap-zoom-container");

  let vertical_position = 0.55;
  let horizontal_position = 0.45;
  let map_zoomed = false;
  let zoom_transform_event = { k: 1, x: 0, y: 0 };

  // tooltip
  const tooltip = d3.select("body").append("div");
  tooltip
    .style("display", "none")
    .style("position", "absolute")
    .style("border", "1px solid #FFFFFF")
    .style("padding-top", "5px")
    .style("padding-left", "10px")
    .style("padding-bottom", "5px")
    .style("padding-right", "10px")
    .style("background", "#0098A7")
    .style("font-size", 12)
    .style("width", "auto")
    .style("border-radius", "2px")
    .style("color", "#4B4B4B");

  let firstDraw = true;
  let buttonPush = false;
  let g;
  let zoom;

  // Map and projection
  var projection = d3
    .geoNaturalEarth1()
    .scale(width / 1.4 / Math.PI)
    .translate([width * horizontal_position, height * vertical_position]);
  let path = d3.geoPath().projection(projection);

  // mapping
  const map_data = d3.map();
  const map_case_studies = d3.map();
  const map_case_studies_obj = d3.map();
  const map_wip_case_studies = d3.map();
  const map_wip_case_studies_obj = d3.map();
  const map_partner_content_names = d3.map();
  const map_partner_content_obj = d3.map();
  const map_non_partner_content_names = d3.map();
  const map_non_partner_content_obj = d3.map();

  var colorScheme = ["#F0F4F6", "#BFE5E9", "#0098A7"];
  var colorScale = d3.scaleOrdinal().domain([0, 1, 2]).range(colorScheme);

  var colorScheme_MouseOver = ["#D5DBDD", "#CCEAED", "#40B2BD"];
  var colorScale_MouseOver = d3
    .scaleOrdinal()
    .domain([0, 1, 2])
    .range(colorScheme_MouseOver);

  // Load external data and boot
  d3.queue()
    .defer(
      d3.json,
      "/Areas/EGH/assets/files/ne_50m_admin_0_countries.geojson.json",
    )
    .await(ready);

  function ready(error, topo) {
    if (error) throw error;

    const map_name = d3.map();

    home_worldmap_data.forEach(function (element) {
      map_name.set(element.code, element.name);
      map_data.set(element.code, +element.total);
      map_case_studies.set(element.code, get_string(element.case_studies));
      map_case_studies_obj.set(element.code, element.case_studies);
      map_wip_case_studies.set(
        element.code,
        get_string(element.wip_case_studies),
      );
      map_wip_case_studies_obj.set(element.code, element.wip_case_studies);
      map_partner_content_names.set(
        element.code,
        get_string(element.partner_content),
      );
      map_partner_content_obj.set(element.code, element.partner_content);
      map_non_partner_content_names.set(
        element.code,
        get_string(element.non_partner_content),
      );
      map_non_partner_content_obj.set(
        element.code,
        element.non_partner_content,
      );
    });

    const countryNamesNotFound = [];
    const mapData = {
      type: topo.type,
      features: topo.features.map((f) => {
        const name = map_name.get(f.properties.iso_a3);
        if (!name) {
          countryNamesNotFound.push({
            code: f.properties.iso_a3,
            name: f.properties.name,
          });
        }
        return { ...f, name: name || f.properties.name };
      }),
    };

    if (countryNamesNotFound.length > 0) {
      console.warn("Some countries were not found in Sitecore");
      console.warn(countryNamesNotFound);
    }

    // select topic dropdown
    $(".js-dropdown_home_worldmap-menu span").on("click", function () {
      if ($(this).hasClass("disabled")) {
        return;
      }
      var topic_selected = $(this).text().trim();
      remove_circles();
      add_circles(topic_selected);
      $(".js-dropdown_home_worldmap .select_topic").text(topic_selected);
      $(".js-dropdown_home_worldmap-close").removeClass("hide");
    });

    $(".js-dropdown_home_worldmap").on("click", function () {
      $(this).toggleClass("is-open");
    });

    // select topic remove
    $(".js-dropdown_home_worldmap-close").on("click", function (e) {
      e.stopPropagation();
      $(this).addClass("hide");

      // remove_circles();

      svg.selectAll(".marks").style("opacity", 1);

      drawWorldMap(mapData, width, height);

      $(".js-dropdown_home_worldmap .select_topic").text(
        dictionaryData.defaultTopicLabel,
      );
    });

    var availableCountries = [];

    home_worldmap_data.forEach(function (element) {
      availableCountries.push(element.name);
    });

    autocomplete(
      document.getElementById("home-worldmap-country-selector"),
      availableCountries,
      mapData,
    );

    drawWorldMap(mapData, width, height);

    $(window).resize(function () {
      var resized_map_container = $("#home-worldmap"),
        resized_map_container_width = resized_map_container.width(),
        resized_map_container_height = resized_map_container.height();

      drawWorldMap(
        mapData,
        resized_map_container_width,
        resized_map_container_height,
      );
    });
  }

  function get_homeworldmap_selector() {
    return $("#homeworldmap-selector").text().trim();
  }

  // function to get names from object and get them as string
  function get_string(obj) {
    var name_string = [];
    for (var i = 0; i < obj.length; i++) {
      name_string.push(obj[i].name);
    }
    return name_string;
  }

  // Draw the map
  function drawWorldMap(mapData, width, height) {
    svg.attr("width", width).attr("height", height);

    if (firstDraw) {
      g = svg
        .append("g")
        .attr("class", "countries")
        .selectAll("path")
        .data(
          mapData.features.filter(function (d) {
            return d.properties.iso_a3 !== "ATA"; // Remove Antarctica
          }),
        )
        .enter()
        .append("path")
        .attr("class", "country")
        .attr("data-label", function (d) {
          return "home_worldmap_" + d.name.replace(/ /g, "_");
        })
        .attr("name_long", function (d) {
          return d.properties.name_long;
        })
        .attr("fill", "#E3EBEE")
        .attr("d", path)
        .style("stroke", function (d) {
          d.total = map_data.get(d.properties.iso_a3) || 0;

          if (d.total > 0) {
            var centroid = path.centroid(d);
            var x, y;
            x = centroid[0];
            y = centroid[1];

            svg
              .select(".countries")
              .append("g")
              .datum(d)
              .style("position", "relative")
              .attr("class", function (d) {
                return "marks marks_" + d.name.replace(/\s/g, "");
              })
              .append("path")
              .attr(
                "d",
                "M7,-0.5 C9.07321429,-0.5 10.9481344,0.338527628 12.3048034,1.69519661 C13.6614724,3.05186559 14.5,4.92678571 14.5,7 C14.5,12.3727045 7.37105132,20.3351431 7.37105132,20.3351431 C7.37105132,20.3351431 7.23992988,20.4815948 6.99974399,20.7359067 C6.75995213,20.481463 6.62894868,20.3351431 6.62894868,20.3351431 C6.62894868,20.3351431 -0.5,12.3727045 -0.5,7 C-0.5,4.92678571 0.338527628,3.05186559 1.69519661,1.69519661 C3.05186559,0.338527628 4.92678571,-0.5 7,-0.5 Z M7,4 C6.172,4 5.42203972,4.33606706 4.87905339,4.87905339 C4.33606706,5.42203972 4,6.172 4,7 C4,7.828 4.33606706,8.57796028 4.87905339,9.12094661 C5.42203972,9.66393294 6.172,10 7,10 C7.828,10 8.57796028,9.66393294 9.12094661,9.12094661 C9.66393294,8.57796028 10,7.828 10,7 C10,6.172 9.66393294,5.42203972 9.12094661,4.87905339 C8.57796028,4.33606706 7.828,4 7,4 Z",
              )
              .attr("transform", "translate(" + (x - 7) + "," + (y - 15) + ")")
              .attr("fill", "#0098A7")
              .attr("stroke", "#FFFFFF")
              .style("cursor", "pointer")
              .on("mousemove", function (d) {
                d3.selectAll(
                  ".marks_" + d.name.replace(/\s/g, "") + " path",
                ).attr("fill", "#FF7700");

                let this_country_name = d.name;
                let color = d.total > 0 ? "#FF7700" : "#B9BFC9";

                tooltip
                  .style("top", d3.event.pageY - 25 + "px")
                  .style("left", d3.event.pageX + 15 + "px")
                  .style("display", "inherit")
                  .html(
                    "<div style='position: absolute; left: 9px; top: 83%; width: 0; height: 0; border: 8px solid transparent; border-right-color: " +
                      "#FFFFFF" +
                      "; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>" +
                      "<div style='position: absolute; left: 11px; top: 83%; width: 0; height: 0; border: 8px solid transparent; border-right-color:" +
                      color +
                      "; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>" +
                      "<span style='color: #FFFFFF; font-weight: 500; text-transform: uppercase; letter-spacing: 1.2px; font-size: 12px; line-height: 15px;'>" +
                      this_country_name +
                      "</span>" +
                      "</div>" +
                      "</div>",
                  )
                  .style("background", color);
              })
              .on("mouseout", function (d) {
                tooltip.style("display", "none");
                if (!map_zoomed) {
                  d3.selectAll(
                    ".marks_" + d.name.replace(/\s/g, "") + " path",
                  ).attr("fill", "#0098A7");
                }
              })
              .on("click", function (d) {
                tooltip.style("display", "none");
                if (!map_zoomed) {
                  d3.selectAll(this).attr("fill", "#FF7700");

                  svg.on(".zoom", null);
                  click_zoom(d);
                  show_country_info(d);
                  d3.selectAll(".marks").style("visibility", "hidden");

                  d3.selectAll(".marks_" + d.name.replace(/\s/g, "")).style(
                    "visibility",
                    "visible",
                  );
                }
              });
          }

          return "#E3EBEE";
        })
        .style("cursor", function (d) {
          return map_data.get(d.properties.iso_a3) != 0 ? "pointer" : "inherit";
        })
        .on("mousemove", function (d) {
          d.total = map_data.get(d.properties.iso_a3) || 0;
          if (d.total > 0) {
            let this_country_color = "#FF7700";
            let this_country_name = d.name;

            if (!map_zoomed) {
              tooltip
                .style("top", d3.event.pageY - 25 + "px")
                .style("left", d3.event.pageX + 15 + "px")
                .style("display", "inherit")
                .html(
                  "<div style='position: absolute; left: 9px; top: 83%; width: 0; height: 0; border: 8px solid transparent; border-right-color: " +
                    "#FFFFFF" +
                    "; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>" +
                    "<div style='position: absolute; left: 11px; top: 83%; width: 0; height: 0; border: 8px solid transparent; border-right-color:" +
                    this_country_color +
                    "; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>" +
                    "<span style='color: #FFFFFF; font-weight: 500; text-transform: uppercase; letter-spacing: 1.2px; font-size: 12px; line-height: 15px;'>" +
                    this_country_name +
                    "</span>" +
                    "</div>" +
                    "</div>",
                )
                .style("background", this_country_color);
              d3.selectAll(
                ".marks_" + d.name.replace(/\s/g, "") + " path",
              ).attr("fill", "#FF7700");
            }
          }
        })
        .on("mouseout", function (d) {
          tooltip.style("display", "none");
          if (!map_zoomed) {
            d3.selectAll(".marks_" + d.name.replace(/\s/g, "") + " path").attr(
              "fill",
              "#0098A7",
            );
          }
        })
        .on("click", function (d) {
          d.total = map_data.get(d.properties.iso_a3) || 0;
          if (!map_zoomed && d.total > 0) {
            tooltip.style("display", "none");
            svg.on(".zoom", null);
            click_zoom(d);
            show_country_info(d);

            d3.selectAll(".marks").style("visibility", "hidden");
            d3.selectAll(".marks_" + d.name.replace(/\s/g, "")).style(
              "visibility",
              "visible",
            );

            d3.selectAll(".marks_" + d.name.replace(/\s/g, "") + " path").attr(
              "fill",
              "#FF7700",
            );
          }
        });

      zoom = d3
        .zoom()
        .scaleExtent([1, 8])
        .translateExtent([
          [0, 0],
          [width, height],
        ])
        .extent([
          [0, 0],
          [width, height],
        ])
        .on("zoom", zoomed);

      $(".js-homepage-map-mount").one("click", function () {
        svg.call(zoom).on("dblclick.zoom", null);
      });

      $("#zoom-in-button").click(function () {
        zoom.scaleBy(svg.transition().duration(750), 1.2);
      });

      $("#zoom-out-button").click(function () {
        zoom.scaleBy(svg.transition().duration(750), 0.8);
      });

      firstDraw = false;
    } else {
      svg
        .selectAll(".country")
        .transition()
        .duration(800)
        .attr("fill", "#E3EBEE");
    }
  }

  function zoomed() {
    zoom_transform_event = d3.event.transform;

    g.attr("transform", zoom_transform_event);
    d3.selectAll(".marks").attr("transform", zoom_transform_event);

    setTimeout(function () {
      var zoom_scale = d3.zoomTransform(svg.node()).k;
      if (zoom_scale == 8) {
        d3.select("#zoom-in-button").classed("btn--disabled", true);
      } else {
        d3.select("#zoom-in-button").classed("btn--disabled", false);
      }
      if (zoom_scale == 1) {
        d3.select("#zoom-out-button").classed("btn--disabled", true);
      } else {
        d3.select("#zoom-out-button").classed("btn--disabled", false);
      }
    }, 1000);
  }

  function update_colors(topic_selected) {
    svg
      .selectAll(".country")
      .transition()
      .duration(800)
      .attr("fill", "#E3EBEE");
  }

  // function to check if a country has any kind of case study (internal, wip internal, partner content)
  function check_if_case_study(topic_selected, country_code) {
    const check_case_studies = map_case_studies.get(country_code);
    const check_wip_case_studies = map_wip_case_studies.get(country_code);
    const check_map_partner_content_names = map_partner_content_names.get(
      country_code,
    );
    const check_map_non_partner_content_names = map_non_partner_content_names.get(
      country_code,
    );

    /* replacing .includes function for compatibility with IE */
    // if (check_case_studies != undefined) { if (check_case_studies.includes(topic_selected)) return 2 };
    if (check_case_studies != undefined) {
      if (check_case_studies.indexOf(topic_selected) > -1) return 2;
    }

    // if (check_wip_case_studies != undefined) { if (check_wip_case_studies.includes(topic_selected)) return 1 };
    if (check_wip_case_studies != undefined) {
      if (check_wip_case_studies.indexOf(topic_selected) > -1) return 1;
    }

    // if (check_map_partner_content_names != undefined) { if (check_map_partner_content_names.includes(topic_selected)) return 1 };
    if (check_map_partner_content_names != undefined) {
      if (check_map_partner_content_names.indexOf(topic_selected) > -1)
        return 1;
    }
    if (check_map_non_partner_content_names != undefined) {
      if (check_map_non_partner_content_names.indexOf(topic_selected) > -1)
        return 1;
    }

    return 0;
  }

  function add_circles(topic_selected) {
    var x, y;
    var countries = svg.selectAll(".country");

    countries.each(function (element) {
      var temp_case_studies = map_case_studies.get(element.properties.iso_a3);

      if (temp_case_studies != undefined) {
        if (temp_case_studies.indexOf(topic_selected) > -1) {
          var centroid = path.centroid(element);
          x = centroid[0];
          y = centroid[1];

          for (let i = 0; i < 4; i++) {
            svg
              .select(".countries")
              .append("g")
              .datum(element)
              .style("position", "relative")
              .attr("class", function (d) {
                return "marks marks_" + d.name.replace(/\s/g, "");
              })
              .append("path")
              .attr(
                "d",
                "M7,-0.5 C9.07321429,-0.5 10.9481344,0.338527628 12.3048034,1.69519661 C13.6614724,3.05186559 14.5,4.92678571 14.5,7 C14.5,12.3727045 7.37105132,20.3351431 7.37105132,20.3351431 C7.37105132,20.3351431 7.23992988,20.4815948 6.99974399,20.7359067 C6.75995213,20.481463 6.62894868,20.3351431 6.62894868,20.3351431 C6.62894868,20.3351431 -0.5,12.3727045 -0.5,7 C-0.5,4.92678571 0.338527628,3.05186559 1.69519661,1.69519661 C3.05186559,0.338527628 4.92678571,-0.5 7,-0.5 Z M7,4 C6.172,4 5.42203972,4.33606706 4.87905339,4.87905339 C4.33606706,5.42203972 4,6.172 4,7 C4,7.828 4.33606706,8.57796028 4.87905339,9.12094661 C5.42203972,9.66393294 6.172,10 7,10 C7.828,10 8.57796028,9.66393294 9.12094661,9.12094661 C9.66393294,8.57796028 10,7.828 10,7 C10,6.172 9.66393294,5.42203972 9.12094661,4.87905339 C8.57796028,4.33606706 7.828,4 7,4 Z",
              )
              .attr("transform", "translate(" + (x - 7) + "," + (y - 15) + ")")
              .attr("fill", "#0098A7")
              .attr("stroke", "#FFFFFF")
              .style("cursor", "pointer")
              .on("mousemove", function (d) {
                if (!map_zoomed) {
                  d3.selectAll(
                    ".marks_" + d.name.replace(/\s/g, "") + " path",
                  ).attr("fill", "#FF7700");
                }

                let this_country_name = d.name;
                let color = d.total > 0 ? "#FF7700" : "#B9BFC9";

                tooltip
                  .style("top", d3.event.pageY - 25 + "px")
                  .style("left", d3.event.pageX + 15 + "px")
                  .style("display", "inherit")
                  .html(
                    "<div style='position: absolute; left: 9px; top: 83%; width: 0; height: 0; border: 8px solid transparent; border-right-color: " +
                      "#FFFFFF" +
                      "; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>" +
                      "<div style='position: absolute; left: 11px; top: 83%; width: 0; height: 0; border: 8px solid transparent; border-right-color:" +
                      color +
                      "; border-left: 0; margin-top: -17px; margin-left: -17px;'></div>" +
                      "<span style='color: #FFFFFF; font-weight: 500; text-transform: uppercase; letter-spacing: 1.2px; font-size: 12px; line-height: 15px;'>" +
                      this_country_name +
                      "</span>" +
                      "</div>" +
                      "</div>",
                  )
                  .style("background", color);
              })
              .on("mouseout", function (d) {
                tooltip.style("display", "none");
                if (!map_zoomed) {
                  d3.selectAll(
                    ".marks_" + d.name.replace(/\s/g, "") + " path",
                  ).attr("fill", "#0098A7");
                }
              })
              .on("click", function (d) {
                tooltip.style("display", "none");
                if (!map_zoomed) {
                  d3.select(this).attr("fill", "#0098A7");
                  svg.on(".zoom", null);
                  click_zoom(d);
                  show_country_info(d);
                  d3.selectAll(".marks").style("visibility", "hidden");

                  d3.selectAll(".marks_" + d.name.replace(/\s/g, "")).style(
                    "visibility",
                    "visible",
                  );
                  d3.selectAll(
                    ".marks_" + d.name.replace(/\s/g, "") + " path",
                  ).attr("fill", "#FF7700");
                }
              });
          }
        }
      }
    });
  }

  function remove_circles() {
    svg.selectAll(".marks").transition().duration(200).style("opacity", 0);
    // .remove();
  }

  function click_zoom(d) {
    var x,
      y,
      k,
      x_pos,
      y_pos,
      country_clicked = d.name,
      stroke_color;
    var b = path.bounds(d);
    var countries = svg.selectAll(".country");
    map_zoomed = true;

    if (d && centered !== d) {
      hide_home_default();

      var centroid = path.centroid(d);

      switch (country_clicked) {
        case "USA":
          x = centroid[0] + width * 0.01;
          y = centroid[1];
          k = 1.5;
          break;
        case "France":
          x = centroid[0] + width * 0.01;
          y = centroid[1] - height * 0.05;
          k = 5.6;
          break;
        case "Russia":
          x = centroid[0] + width * 0.01;
          y = centroid[1] + height * 0.1;
          k = 1.2;
          break;
        case "Netherlands":
          x = centroid[0];
          y = centroid[1];
          k = 35.9;
          break;
        case "New Zealand":
          x = centroid[0];
          y = centroid[1];
          k = 8;
          break;
        case "Fiji":
          x = centroid[0] + width * 0.05;
          y = centroid[1];
          k = 8;
          break;
        case "Rwanda":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Brazil":
          x = centroid[0];
          y = centroid[1];
          k = 4;
          break;
        case "India":
          x = centroid[0];
          y = centroid[1] + 10;
          k = 4;
          break;
        case "Nepal":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Peru":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Honduras":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Senegal":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Liberia":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Ethiopia":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Zambia":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Malawi":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Kyrgyz Republic":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Bangladesh":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Cambodia":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        case "Ghana":
          x = centroid[0];
          y = centroid[1];
          k = 3;
          break;
        default:
          x = centroid[0];
          y = centroid[1];
          k =
            0.5 /
            Math.max((b[1][0] - b[0][0]) / width, (b[1][1] - b[0][1]) / height);
          break;
      }

      centered = d;
      x_pos = 0.7;
      y_pos = 0.55;
      stroke_color = "#E3EBEE"; // efefef;
      countries
        .attr("class", function (d) {
          if (d.name == country_clicked) {
            d.total = map_data.get(d.properties.iso_a3) || 0;
            return d.total != 0
              ? "country"
              : "country fill-turquoise-important";
          } else {
            return "country";
          }
        })
        .attr("fill", "#E3EBEE")
        .style("cursor", "auto");
    }

    g.transition()
      .duration(1500)
      .attr(
        "transform",
        "translate(" +
          width * x_pos +
          "," +
          height * y_pos +
          ")" +
          "scale(" +
          k +
          ")" +
          "translate(" +
          -x +
          "," +
          -y +
          ")",
      );

    d3.selectAll(".marks")
      .transition()
      .duration(1500)
      .attr(
        "transform",
        "translate(" +
          width * x_pos +
          "," +
          height * y_pos +
          ")" +
          "scale(" +
          k +
          ")" +
          "translate(" +
          -x +
          "," +
          -y +
          ")",
      )
      .selectAll("path")
      .attr("transform", function () {
        return d3.select(this).attr("transform") + " scale(" + 0.5 + ")";
      });
  }

  function reset_to_map() {
    var x, y, k, x_pos, y_pos, stroke_color;
    var countries = svg.selectAll(".country");

    map_zoomed = false;
    svg.call(zoom).on("dblclick.zoom", null);

    show_home_default();

    x = width * horizontal_position;
    y = height * vertical_position;
    k = 1;
    centered = null;
    x_pos = horizontal_position;
    y_pos = vertical_position;
    stroke_color = "#c1c1c1";
    countries
      .attr("class", "country")
      .attr("fill", "#E3EBEE")
      .style("cursor", "pointer");

    g.selectAll("path").classed(
      "active",
      centered &&
        function (d) {
          return d === centered;
        },
    );

    g.transition()
      .duration(1500)
      .attr(
        "transform",
        "translate(" +
          width * x_pos +
          "," +
          height * y_pos +
          ")" +
          "scale(" +
          k +
          ")" +
          "translate(" +
          -x +
          "," +
          -y +
          ")",
      );

    d3.selectAll(".marks")
      .transition()
      .duration(1500)
      .attr(
        "transform",
        "translate(" +
          width * x_pos +
          "," +
          height * y_pos +
          ")" +
          "scale(" +
          k +
          ")" +
          "translate(" +
          -x +
          "," +
          -y +
          ")",
      )
      .selectAll("path")
      // .transition()
      // .duration(1500)
      .attr("transform", function () {
        console.log(d3.select(this).attr("transform"));

        return (
          d3.select(this).attr("transform").split(" scale")[0] +
          " scale(" +
          1 +
          ")"
        );
      });

    zoom_transform_event = d3.zoomIdentity.translate(0, 0).scale(1);

    d3.selectAll(".topic-circles").attr("transform", zoom_transform_event);
    d3.selectAll(".topic-rects").attr("transform", zoom_transform_event);

    zoom_transform_event;
  }

  function show_country_info(data) {
    // update React App for Country Info
    const topic_selected = get_homeworldmap_selector();
    data.topicSelected = topic_selected;
    showCountryInfo(data);
  }

  // RETURN TO MAP ACTION BUTTON return-to-map
  function show_home_default() {
    zoom_transform_event = d3.zoomIdentity.translate(0, 0).scale(1);

    zoom_container.style("visibility", "visible");
    map_default_text.style("visibility", "visible");

    d3.select("#home-worldmap-input-container").style("visibility", "visible");

    svg
      .selectAll(".marks")
      .transition()
      .duration(0.01)
      .delay(1500)
      .style("opacity", 1)
      .attr("transform", zoom_transform_event);

    d3.selectAll(".marks").style("visibility", "inherit");
    d3.selectAll(".marks path").attr("fill", "#0098A7");
  }

  function hide_home_default() {
    map_default_text.style("visibility", "hidden");
    zoom_container.style("visibility", "hidden");

    d3.select("#home-worldmap-input-container").style("visibility", "hidden");

    // remove_circles();
  }

  function autocomplete(inp, arr, mapData) {
    var autocompletedText = document.getElementById(
      "home-worldmap-country-selector-autocomplete",
    );

    inp.closest("form").addEventListener("submit", (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();

      if (inp.value.length > 0) {
        mapTransition();
      }
    });

    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function (e) {
      var val = this.value;
      if (!val) {
        autocompletedText.value = "";
        return false;
      }

      if (countSearchResults(arr, val) == 0) {
        autocompletedText.value = "";
      }

      /*for each item in the array...*/
      for (let i = 0; i < arr.length; i++) {
        /*check if the item starts with the same letters as the text field value:*/
        if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
          var newValue = "",
            j = 0;

          for (j = 0; j < val.length; j++) {
            newValue += val[j];
          }
          for (var k = j; k < arr[i].length; k++) {
            newValue += arr[i][k];
          }

          autocompletedText.value = newValue;

          // remove orange rectangle
          remove_rect();
          add_rect(arr[i]); // add it pointing to the country
        }
      }
    });

    function mapTransition() {
      if (autocompletedText.value.length === 0) {
        return false;
      }

      const country_d = mapData.features.find(function (d) {
        return d.name.toUpperCase() == autocompletedText.value.toUpperCase();
      });

      if (!country_d || country_d.length === 0) {
        return false;
      }

      autocompletedText.value = "";
      inp.value = "";

      click_zoom(country_d);
      show_country_info(country_d);
      remove_rect();
      svg.on(".zoom", null);
    }

    function countSearchResults(array, value) {
      var resultsCount = 0;

      array.forEach((a) => {
        if (a.substr(0, value.length).toUpperCase() == value.toUpperCase()) {
          resultsCount++;
        }
      });
      return resultsCount;
    }
  }

  return { resetMap: reset_to_map };
}
